import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    container: {
      maxWidth: '600px',
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '& h2': {
        fontWeight: '400',
      },
      '& img': {
        width: '25px',
        marginRight: '8px',
      },
    },
    body: {
      padding: '24px 0',
      '& h6': {
        color: '#222222',
        fontSize: '16px',
        fontWeight: '300',
        lineHeight: '24px',
      },
      '& .errorMessage': {
        fontWeight: 'bold',
        paddingBottom: '20px',
      },
    },
    buttonsContainer: {
      textAlign: 'right',
      '& .closeButton': {
        fontWeight: 'bold',
      },
      '& .rejectButton': {
        marginLeft: '16px',
      },
    },
    paddingBottom: {
      paddingBottom: '20px',
    },
  }),
  { name: 'RejectModal' },
);

export default useStyles;
